import { IConversationPatch } from '../../EnterpriseGPTApi/EnterpriseGPTApiV1Client';
import { AppConversation } from '../models/conversation';

export type ConversationAction =
    | { type: 'SET_CONVERSATIONS'; payload: AppConversation[]; cursor?: string }
    | { type: 'ADD_CONVERSATION'; payload: AppConversation }
    | { type: 'APPEND_CONVERSATIONS'; payload: AppConversation[] }
    | { type: 'REMOVE_CONVERSATION'; payload: string }
    | { type: 'CLEAR_CONVERSATIONS' }
    | { type: 'UPDATE_CONVERSATION'; payload: { id: string; patch: IConversationPatch } }
    | { type: 'SET_ACTIVE_CONVERSATION'; payload: string }
    | { type: 'UPDATE_ACTIVE_CONVERSATION'; payload: { id: string; conversation: AppConversation } }
    | { type: 'SET_CONVERSATIONS_CURSOR'; payload: string | undefined };

export const setActiveConversation = (payload: string): ConversationAction => ({
    type: 'SET_ACTIVE_CONVERSATION',
    payload,
});

export const setConversationsAction = (payload: AppConversation[], cursor?: string): ConversationAction => ({
    type: 'SET_CONVERSATIONS',
    payload: payload,
    cursor,
});

export const addConversationAction = (payload: AppConversation): ConversationAction => ({
    type: 'ADD_CONVERSATION',
    payload,
});

export const appendConversationsAction = (payload: AppConversation[]): ConversationAction => ({
    type: 'APPEND_CONVERSATIONS',
    payload,
});

export const removeConversationAction = (payload: string): ConversationAction => ({
    type: 'REMOVE_CONVERSATION',
    payload,
});

export const clearConversationsAction = (): ConversationAction => ({
    type: 'CLEAR_CONVERSATIONS',
});

export const updateConversationAction = (payload: { id: string; patch: IConversationPatch }): ConversationAction => ({
    type: 'UPDATE_CONVERSATION',
    payload,
});

export const updateActiveConversationAction = (payload: { id: string; conversation: AppConversation }): ConversationAction => ({
    type: 'UPDATE_ACTIVE_CONVERSATION',
    payload,
});

export const setConversationsCursorAction = (payload: string | undefined): ConversationAction => ({
    type: 'SET_CONVERSATIONS_CURSOR',
    payload,
});
